import SeeProductDetails from 'components/SeeProductDetails/SeeProductDetails';
import { withSeeProductDetailsProps } from 'viewModel/sharedComponents/seeProductDetails/withSeeProductDetailsProps';

export default withSeeProductDetailsProps(SeeProductDetails);
